import { getBlisterUnitPrice } from './blisterUtils'

export const formatPrice = (price) => {
  return new Intl.NumberFormat().format(price)
}

export const getMinPrice = (blisters) => {
  if (blisters && blisters.length > 0) {
    const prices = blisters.map(blister => getBlisterUnitPrice(blister)).filter(p => p > 0)
    if (prices.length) return Math.min(...prices)
  }
  return 0
}

export const getMaxPrice = (blisters) => {
  if (blisters && blisters.length > 0) {
    const prices = blisters.map(blister => getBlisterUnitPrice(blister)).filter(p => p > 0)
    if (prices.length) return Math.max(...prices)
  }
  return 0
}
